import Vue from "vue";
import GradesOverviewWidget from "./components/GradesOverviewWidget.vue";
import store from './store/index';

Vue.config.productionTip = false;

let GradesWidgets = document.querySelectorAll('widget-grades-overview');
if (GradesWidgets.length) {
    GradesWidgets.forEach(el => {
        new Vue({
            el: el,
            store,
            render(h) {
                let language = this.$el.attributes.getNamedItem('language');
                let vuNetId = this.$el.attributes.getNamedItem('vunetid');
                let excurid = this.$el.attributes.getNamedItem('excurid');
                let moduleSubscribeLink = this.$el.attributes.getNamedItem('modulesubscribelink');

                //read vunet from url params if specified
                let hash = window.location.hash.replace('#/', '');
                let match = hash.match(/vunetid=([^&]+)/); //Find value for the vunetid from the hash string
                let vuNetIdFromUrl = match ? match[1] : null;

                return h(GradesOverviewWidget, {
                    props: {
                        configRaw: {
                            language: language ? language.value : null,
                            vuNetIdStudent: vuNetIdFromUrl ? vuNetIdFromUrl : vuNetId ? vuNetId.value : null,
                            vuNetIdUser: vuNetId ? vuNetId.value : null,
                            excurid: excurid ? excurid.value : null,
                            moduleSubscribeLink: moduleSubscribeLink ? moduleSubscribeLink.value : null
                        }
                    }
                });
            }
        });
    });
}
